import { Formik } from "formik";
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Col, Form, Row, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import InputField from "../InputField/InputField";
import SlectInputField from "../SlectInputField/SlectInputField";
import * as Yup from "yup";
import CheckboxField from "../CheckboxField";
import TextareaField from "../TextareaField/TextareaField";
import * as AuthVerify from '../../lib/common';
import Axios from '../../lib/axios/axiosInstance';
import { Flip, Slide, toast } from 'react-toastify';
import { commonGet } from "../../services/auth";
import { Space, Spin } from 'antd';
import RASelect from 'react-select/async';
import Modal from 'react-bootstrap/Modal';
import CustomDateTimePicker from '../InputField/CustomDateTimePicker';
import ApprovalLoop from '../OrderDetails/ApprovalLoop';
import queryString from "query-string";

const ShoppingCartInfo = ({ checkoutTitle }) => {
  const navigate = useNavigate();
  const [saveAsTemplateModal, setSaveAsTemplateModal] = useState(false);
  const [spinner, setSpinner] = useState(false);
  const queryParams = queryString.parse(window.location.search)
  //const [filledInfo, setFilledInfo] = useState(false);
  const [initialVal, setInitialVal] = useState({
    reqName: "",
    email: "",
    companyName: "",
    contact: "",
    address1: "",
    country1: "",
    state1: "",
    city1: "",
    zipCode1: "",
    address2: "",
    country2: "",
    state2: "",
    city2: "",
    zipCode2: "",
    contact1: "",
    sameAsBillingInfo: false,
    shippigName: "",
    shippingEmail: "",
    shippingContact: "",
    shippingAddress: "",
    shippingCountry: "",
    shippingState: "",
    shippingCity: "",
    shippingZipCode: "",
    shipptc: '',
    shipphone: '',
    budgetPeriod: "",
    pendingValue: "",
    initialValue: "",
    balanceValue: "",
    depletedValue: "",
    poNo: "",
    description: "",
    submittedBy: "",
    submittedDate: "",
    approovedBy: "",
    approvedDate: "",
    shipdeldate: "",
    earlyTime: false,
    lateTime: false,
    remarks: "",
  });

  const [userDetails, setUserDetails] = useState(false);
  const [addressDetails, setAddressDetails] = useState(false);
  const [billingAddress, setBillingAddress] = useState(false);
  const [cartDetails, setCartDetails] = useState(false);
  const [shippingAddress, setShippingAddress] = useState(false);
  const [sameAsShippingAddress, setSameAsShippingAddress] = useState(false);
  const [submitForApp, setSubmitForApp] = useState(false);
  const [createdat, setCreatedat] = useState(false);
  const [availableBudgets, setAvailableBudgets] = useState(false);
  const [loadBudgetData, setLoadBudgetData] = useState(false);
  const [selectedBudget, setSelectedBudget] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [shippingModes, setShippingModes] = useState(false);
  const [selectedShippingMode, setSelectedShippingMode] = useState(false);
  const [paymentModes, setPaymentModes] = useState(false);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState(false);
  const [askingDate, setAskingDate] = useState(null);
  const [insuffStockModel, setInsuffStockModel] = useState(false);
  const [editOrderModel, setEditOrderModel] = useState(false);
  const [reason, setReason] = useState('');
  const [reasonModel, setReasonModel] = useState(false);
  const [applycorpsetting, setApplycorpsetting] = useState(false);
  const [costCenter, setCostCenter] = useState(false);
  const [costCenters, setCostCenters] = useState(false);
  const transaction_id = useRef(false);
  
  const [editPermission, setEditPermission] = useState(false);
  const [deletePermission, setDeletePermission] = useState(false);
  const [viewPermission, setViewPermission] = useState(false);
  const [addNewPermission, setAddNewPermission] = useState(false);
  const [requestors, setRequestors] = useState([]);

  useEffect(() => {
    const permission =AuthVerify.getPermissions("ShippingAddress");
    setViewPermission(permission?.view);
    setEditPermission(permission?.edit);
    setDeletePermission(permission?.delete);
    setAddNewPermission(permission?.addnew);
  }, []);

  const getAccountDetails = async (arnum) => {
    await Axios.get('/profile/location?arnum=' + arnum)
      .then(function (response) {
        if (response.data && response.data?.data) {
          if (response.data?.data?.addresses) setAddressDetails(response.data?.data?.addresses);
          response.data?.data?.addresses.forEach(item => {
            if (item.default == true) {
              setShippingAddress(item.dellocname);
            }
          })

        } else {
          toast.error('Shipping Address data fetching failed !', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Flip,
          });
          return false;
        }
      })
      .catch(function (error) {
        setAddressDetails(false);
      });
  };

  useEffect(() => {
    const userDetails = AuthVerify.getUser();
    if (!userDetails) window.location.href = '/';
    if (userDetails.applycorpsetting) {
      setApplycorpsetting(userDetails.applycorpsetting)
      getCostCenter()
      getCostCenters(userDetails.arnum)
    }
    setUserDetails(userDetails);
    // getAccountDetails(userDetails?.arnum);
    setBillingAddress(false);
    AuthVerify.getCartDeatils(true).then((data) => {
      setAddValue(data.carth?.billaddr1);

      if (data.shippingaddresses) setAddressDetails(data.shippingaddresses);
      data.shippingaddresses.forEach(item => {
        if (item.default == true) {
          setShippingAddress(item.dellocname);
        }
      })

      setCityValue(data.carth?.billcity);
      setCountryValue(data.carth?.billcountry);
      setStateValue(data.carth?.billstate);
      setPostValue(data.carth?.billpostcode);
      if (data.carth?.billpostcode) window.setPostalCode(data.carth?.billpostcode, 'customPostalCodeSelectCart');
      initialVal.reqName = data.carth?.billptc ?? '';
      initialVal.companyName = data.carth?.arname ?? '';
      initialVal.email = data.carth?.billemail ?? '';
      initialVal.contact = data.carth?.billphone ?? '';
      initialVal.address2 = data.carth?.billaddr2 ?? '';
      initialVal.remarks = data.carth?.orderremark1 ?? '';
      setShippingModes(data.shippingmodes);
      setPaymentModes(data.paymodes);
      if (data.paymodes && data.paymodes.length == 1) {
        setSelectedPaymentMode(data.paymodes[0].varid)
      }
      const found = data.requestors.find((item) => item.value == data.carth?.billptc);
      if (found)
      {
        initialVal.shipptc = found.label ?? '';
        initialVal.shipphone = found.phone ?? '';
      }
      setInitialVal(initialVal);
      setSameAsShippingAddress(data.carth?.sameAsBillingInfo);
      // setCreatedat(data?.shipdeldatesettings[0].mindate.split('T')[0]);
      let varSpecificdate = data?.shipdeldatesettings[0].specificdate??data?.shipdeldatesettings[0].defaultdate;
      setCreatedat(varSpecificdate?.split('T')[0]);
      //data.shipdeldatesettings[0].specificdate=varSpecificdate;
      // data.carth.budgetdisplay=true;
      // data.carth.approvaldisplay = true;
      // data.carth.confirmbtndisplay = true;
      // data.carth.submitbtndisplay =false;
      setCartDetails(data);
      setRequestors(data.requestors)
      getAvailableBudgets();

    });
  }, [])

  async function getCostCenter() {
    // userDetails.arnum="ARM-90195171";
    await Axios.get(`/account/costcenter`)
      .then(async (costcenters) => {
        if (costcenters.status == 200 && costcenters.data?.data) {
          var data = costcenters.data?.data.filter(x => x.active == true)
          setCostCenter(data.length > 0 ? data[0] : false);
        } else {
          setCostCenter(false);
        }
      })
  }

  async function getCostCenters(arnum) {
    // userDetails.arnum="ARM-90195171";
    await Axios.get(`/corporate/costcenter/${arnum}`)
      .then(async (costcenters) => {
        if (costcenters.status == 200 && costcenters.data?.data?.costcenters) {
          var dd = [];
          costcenters.data?.data?.costcenters.forEach(element => {
            dd.push({ label: element.ccname, value: element.ccnum })
          });
          setCostCenters(dd);
        } else {
          setCostCenters([]);
        }
      })
  }

  useEffect(() => {
    if (availableBudgets) {
      loadBudget();
    }
  }, [availableBudgets])

  const getAvailableBudgets = async () => {
    var user = AuthVerify.getUser();
    if (!user) window.location.href = '/';
    setUserDetails(user);
    // Get Budgets available for a cart
    // https://devb2b.bizpoint-intl.com:3082/api/cart/budget/:refnum
    await Axios.get(`/cart/budget/${user.refnum}`)
      .then(function (response) {
        if (response && response.data?.data?.budgets) {
          setAvailableBudgets(response.data?.data.budgets);
          return response.data?.data.budgets;
        }
        else {
          setAvailableBudgets([]);
          return false;
        }
      })
      .catch(function (error) {
        setAvailableBudgets([]);
        return false;
      });
  }

  const loadBudget = async (budgetnum) => {
    const session = AuthVerify.getUser();
    if (!session) window.location.href = '/';
    if (budgetnum) session.budgetnum = budgetnum;
    setSelectedBudget(session.budgetnum);
    let data = availableBudgets.filter(x => x.budgetnum == session.budgetnum)[0];
    setLoadBudgetData(data);
    AuthVerify.setSession(session);
  }
  const [lastSubmittedValue, setLastSubmittedValue] = useState(false);
  const [specificDateFound, setSpecificDateFound] = useState(false);

  const allowPartial = useRef(false);

  const checkPartialDelivery = async (values) => {
    if (userDetails.role == 'Individual') {
      checkPaymentgateway(values)
    } else {
      allowPartial.current = false;
      setLastSubmittedValue(values);
      let insufficient = true;
      AuthVerify.getCartDeatils(true)
        .then((response) => {
          if (response.items.length > 0) {
            response.items.map((item) => {
              if (item.availability === 'N') {
                setInsuffStockModel(true);
                insufficient = false;
              }
            })
          }
        })
        .then(() => {
          if (insufficient) {
            checkPaymentgateway(values)
          }
        })
    }
  }

  const verifyCart = async (values) => {
    // Verify Cart
    // api/cart/verify/:refnum
    var user = AuthVerify.getUser();
    let carth = getRequestBody(values);
    const val = {
      carth: carth
    };
    return await Axios.post(`/cart/verify/${user.refnum}`, val)
      .then(function (response) {
        if (response && response.data?.success) {
          return true;
        }
        else {
          if (response.data?.error)
            toast.error(response.data?.error, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
              transition: Slide,
            });

          return false;
        }
      })
      .catch(function (error) {
        return false;
      });
  }

  const submitFormHandler = async (values) => {
    var result = true;
    if (!shippingAddress) {
      toast.error('Please Select Shipping Address !', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
        transition: Slide,
      });
      return false;
    }
    else if (!sameAsShippingAddress && userDetails.role == 'Corporate') {
      var message = "";
      if (!postValue) { result = false; message = "Post Code can not be empty" }
      else if (!addValue) { result = false; message = "Address can not be empty" }
      else if (!countryValue) { result = false; message = "Country can not be empty" }
      else if (!stateValue) { result = false; message = "State can not be empty" }
      else if (!cityValue) { result = false; message = "Address can not be empty" }
      if (!result) {
        toast.error(message, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
          transition: Slide,
        });
        return false;
      }
    }
    if (userDetails.role == 'Corporate') {
      if (!values.reqName) { result = false; message = "Billing address req name can not be empty" }
      else if (!values.email) { result = false; message = "Billing address email can not be empty" }

      if (!result) {
        toast.error(message, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
          transition: Slide,
        });
        return false;
      }
    }

    verifyCart(values).then((response) => {
      if (response) {
        cartDetails.items.forEach((item) => {
          if (item.template === 'Y')
            item.templatedata = userDetails.items[item.matnum]?.templatedata ?? null;
        })
        
        setSpinner(true);
        checkPartialDelivery(values);
        // submitFunction(values);
      }
    })
  }

  const checkPaymentgateway = async (values) => {
    try {
      if (!values) values = lastSubmittedValue;
      if (!values.paymode) {
        values.paymode = selectedPaymentMode;
      }

      if (values.paymode == '04') {
        var data = getRequestBody(values);
        const result = AuthVerify.setSessiondata(data, "WaitingForPayment", true);
        if (result) {
          await AuthVerify.redirectUrlForPayment(cartDetails.carth.refnum, cartDetails.carth.totalamt).then(async response => {
            if (response) {
              let sessionData = AuthVerify.getSessiondata("WaitingForPayment");
              sessionData.paymentResponse = response;
              AuthVerify.setSessiondata(sessionData, "WaitingForPayment", true);
              window.location.href = response.payment_url;
            }
          })
        }
      } else {
        submitFunction(values)
      }

    } catch (error) {
      console.log(error)
    }
  }

  const getRequestBody = (values) => {
    const selectedShippingAddress = addressDetails.filter(x => x.dellocname == shippingAddress)[0];
    const val = {
      refnum: userDetails.refnum,
      billaddr1: sameAsShippingAddress ? selectedShippingAddress.addr1 : addValue,
      billaddr2: sameAsShippingAddress ? selectedShippingAddress.addr2 : values.address2,
      billaddr3: null,
      billcity: sameAsShippingAddress ? selectedShippingAddress.city : cityValue,
      billcountry: sameAsShippingAddress ? selectedShippingAddress.country : countryValue,
      billstate: sameAsShippingAddress ? selectedShippingAddress.state : stateValue,
      billpostcode: sameAsShippingAddress ? selectedShippingAddress.postcode : postValue,
      billphone: sameAsShippingAddress ? selectedShippingAddress.phone : values.contact,
      billemail: values.email,
      shipemail: selectedShippingAddress.email ?? null,
      shipphone: values.shipphone,
      shipaddr1: selectedShippingAddress.addr1,
      shipaddr2: selectedShippingAddress.addr2,
      shipaddr3: null,
      shipcity: selectedShippingAddress.city,
      shipcountry: selectedShippingAddress.country,
      shipstate: selectedShippingAddress.state,
      shippostcode: selectedShippingAddress.postcode,
      shipdelremark1: values.remarks,
      billptc: values.reqName,
      shipptc: values.shipptc,
      items: cartDetails.items,
      ponum: values.poNo,
      budgetnum: selectedBudget,
      paymode: selectedPaymentMode,
      shipmode: selectedShippingMode,
      allowpartial: allowPartial.current,
      shipdeldateremark: reason.length>0?reason:values.remarks,
      shipclocnum: selectedShippingAddress.clocnum,
      podescription: values.description,
      shipdeldate: createdat
    }
    return val;
  }

  useEffect(() => {
    if (queryParams.transaction_id && transaction_id.current != queryParams.transaction_id) {
      transaction_id.current = queryParams.transaction_id;
      submitFunction(null, queryParams.transaction_id)
    }
  }, [queryParams])

  const submitFunction = async (values, transaction_id) => {
    try {
      if (!values) values = lastSubmittedValue;
      if (!values && transaction_id) {
        let carth = AuthVerify.getSessiondata("WaitingForPayment");
        // carth.items=cartDetails.items;
        if (!carth) return;
        if (transaction_id == carth.paymentResponse.transaction_id) {
          await AuthVerify.checkPayment(transaction_id).then(async success => {
            if (success.response_code == '0') {
              const val = {
                carth: carth
              };
              await Axios.post(`/cart/confirm/${carth.refnum}`, val)
                .then(async (refnum) => {
                  if (refnum?.data && refnum.status == 200) {
                    let user = AuthVerify.getUser();
                    user.items = {};
                    AuthVerify.setSession(userDetails);
                    toast.success('Order Confirmed Successfully !', {
                      position: toast.POSITION.TOP_CENTER,
                      autoClose: 3000,
                      transition: Slide,
                    });
                    await AuthVerify.updatePaymentStatus(carth, 2).then(() => {
                      navigate("/shopping-order-confirm");
                    });
                  }
                });
            } else {
              navigate('/page?name=payment_failed');
            }
          })
        }
        // AuthVerify.removeSession("WaitingForPayment");
      }
      else if (values) {
        let carth = getRequestBody(values);
        const val = {
          carth: carth
        };
        var approvalRequest = false;
        if (submitForApp) {
          approvalRequest = true;
          setSubmitForApp(false);
        }
        if (approvalRequest) {
          await AuthVerify.submitForApproval(val).then(result => {
            if (result) {
              navigate('/my-account');
            }
          });
        } else {
          await Axios.post(`/cart/confirm/${userDetails.refnum}`, val)
            .then(async (refnum) => {
              if (refnum?.data && refnum.status == 200) {
                userDetails.items = {};
                AuthVerify.setSession(userDetails);
                toast.success('Order Confirmed Successfully !', {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 3000,
                  transition: Slide,
                });
                navigate("/shopping-order-confirm");
              } else {
                toast.error(refnum.statusText, {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 3000,
                  transition: Slide,
                });
              }
            });
        }
      }
      else {
        return false;
      }
    } catch (error) {
      console.log(error)
    }
  }

  //-------------------------------------------------
  const [countries, setCountries] = useState([]);
  const [allCountries, setAllCountries] = useState([]);
  const [countryValue, setCountryValue] = useState('');
  const [allStates, setAllStates] = useState([]);
  const [states, setStates] = useState([]);
  const [stateValue, setStateValue] = useState('');
  const [cityValue, setCityValue] = useState('');
  const [allCities, setAllCities] = useState([]);
  const [cities, setCities] = useState([]);
  const [addValue, setAddValue] = useState('');
  const [addValueChange, setAddValueChange] = useState('');
  const [postValue, setPostValue] = useState('');
  const [defaultValue, setDefaultValue] = useState(true);

  const getCountries = async () => {
    var allCountries = await commonGet(null, `https://devb2b.bizpoint-intl.com:3082/api/sysvar/countryList`, true);
    var dd = [];
    setAllCountries(allCountries.data.countryList);
    setAllAddCountries(allCountries.data.countryList);
    allCountries?.data?.countryList.forEach(element => {
      dd.push({ label: element.grp.varname, value: element.grp.varname })
    });
    setCountries(dd);
    setAddCountries(dd);
  };

  async function handleCountryChange(event) {
    var result = allCountries.filter(x => x.grp.varname == event.target.value)[0];
    var dd = [];
    if (result.subgrp.length > 0) {
      setAllStates(result.subgrp);
      result.subgrp.forEach(element => {
        dd.push({ label: element.grp.varname, value: element.grp.varname })
      });
    }
    setStates(dd);
    setCities([]);
    let countryName = countries.filter(x => x.value == event.target.value)[0]?.label
    setCountryValue(countryName);
  }

  async function handleStateChange(event) {
    var result = allStates.filter(x => x.grp.varname == event.target.value)[0];
    var dd = [];
    setAllCities(result);
    result.subgrp.forEach(element => {
      dd.push({ label: element.grp.varname, value: element.grp.varname })
    });
    setCities(dd);
    setStateValue(states.filter(x => x.value == event.target.value)[0]?.label);
  }

  async function handleCityChange(event) {
    setCityValue(cities.filter(x => x.value == event.target.value)[0]?.label);
  }

  useEffect(async () => {
    getCountries();
  }, [])

  useEffect(async () => {
    if (countryValue && countryValue != '' && defaultValue && allCountries.length > 0) {
      handleCountryChange({ target: { value: countryValue } });
    }
  }, [countries, countryValue])

  useEffect(async () => {
    if (stateValue && defaultValue && allStates.length > 0) {
      handleStateChange({ target: { value: stateValue } });
      setDefaultValue(false);
    }
  }, [allStates, stateValue])

  function handlePostalChange(event) {
    const postalDiv = event.label.split(' ');
    var postCode = "00";
    for (let index = 0; index < postalDiv.length; index++) {
      if (Number(postalDiv[index]) > 0) {
        postCode = postalDiv[index];
      }
    }
    setPostValue(postCode);
    setAddValue(event.value);
    setAddValueChange(event.value);
  }

  useEffect(async () => {
    if (addValue) {
      window.setPostalCode(addValue);
    }
  }, [addValueChange])

  const filterPostalCodes = async (inputValue) => {
    var result = await commonGet(null, `https://developers.onemap.sg/commonapi/search?searchVal=${inputValue}&returnGeom=Y&getAddrDetails=Y&pageNum=1`, true);
    var dd = [];
    if (result.data.results && result.data.results.length > 0) {
      result.data.results.forEach(element => {
        dd.push({ label: element.SEARCHVAL + "\n" + element.ADDRESS, value: element.ADDRESS })
      });
    }
    return dd.filter((i) =>
      i.label.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  const promiseOptions = (inputValue) =>
    new Promise((resolve) => {
      if (inputValue.length > 1) {
        setTimeout(() => {
          resolve(filterPostalCodes(inputValue));
        }, 1000);
      }
    });

  useEffect(async () => {
    if (postValue || addValue) {
      window.setPostalCode(postValue ?? addValue);
    }
  }, [addValue])

  //--------------------------------

  //-------------------------------------------------

  const defaultAddressValue = {
    arnum: '',
    dellocname: '',
    addr1: '',
    addr2: '',
    postcode: '',
    city: '',
    state: '',
    country: '',
    phone: '',
    uuid: '',
    ptc: ''
  };

  const [initialAddValue, setInitialAddValue] = useState(defaultAddressValue);

  const [allAddCountries, setAllAddCountries] = useState([]);
  const [addCountries, setAddCountries] = useState([]);
  const [addCountryValue, setAddCountryValue] = useState('');
  const [addAllStates, setAddAllStates] = useState([]);
  const [addStates, setAddStates] = useState([]);
  const [addStateValue, setAddStateValue] = useState('');
  const [addAllCities, setAddAllCities] = useState([]);
  const [addCities, setAddCities] = useState([]);
  const [addCityValue, setAddCityValue] = useState('');
  const [addAddValue, setAddAddValue] = useState('');
  const [addPostValue, setAddPostValue] = useState('');

  async function handleAddCountryChange(event) {
    var result = allAddCountries.filter(x => x.grp.varname == event.target.value)[0];
    var dd = [];
    if (result?.subgrp.length > 0) {
      setAddAllStates(result.subgrp);
      result?.subgrp.forEach(element => {
        dd.push({ label: element.grp.varname, value: element.grp.varname })
      });
    }
    setAddStates(dd);
    setAddCities([]);
    setAddCountryValue(addCountries.filter(x => x.value == event.target.value)[0]?.label);
  }

  async function handleAddStateChange(event) {
    var result = addAllStates.filter(x => x.grp.varname == event.target.value)[0];
    var dd = [];
    setAddAllCities(result);
    result?.subgrp.forEach(element => {
      dd.push({ label: element.grp.varname, value: element.grp.varname })
    });
    setAddCities(dd);
    setAddStateValue(addStates.filter(x => x.value == event.target.value)[0]?.label);
  }

  async function handleAddCityChange(event) {
    setAddCityValue(addCities.filter(x => x.value == event.target.value)[0]?.label);
  }

  useEffect(async () => {
    getCountries();
  }, [])

  useEffect(async () => {
    if (addCountries.length > 0) {
      handleAddCountryChange({ target: { value: addCountryValue } });
    }
  }, [addCountries, countries])

  useEffect(async () => {
    if (addStates.length > 0) {
      handleAddStateChange({ target: { value: addStateValue } });
      setDefaultValue(false);
    }
  }, [addAllStates])

  function handleAddPostalChange(event) {
    const postalDiv = event.label.split(' ');
    var postCode = "00";
    for (let index = 0; index < postalDiv.length; index++) {
      if (Number(postalDiv[index]) > 0) {
        postCode = postalDiv[index];
      }
    }
    setAddPostValue(postCode);
    setAddAddValue(event.value);
    setAddValueChange(event.value);
  }

  const filterAddPostalCodes = async (inputValue) => {
    var result = await commonGet(null, `https://developers.onemap.sg/commonapi/search?searchVal=${inputValue}&returnGeom=Y&getAddrDetails=Y&pageNum=1`, true);
    var dd = [];
    if (result.data.results && result.data.results.length > 0) {
      result.data.results.forEach(element => {
        dd.push({ label: element.SEARCHVAL + "\n" + element.ADDRESS, value: element.ADDRESS })
      });
    }
    return dd.filter((i) =>
      i.label.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  const addPromiseOptions = (inputValue) =>
    new Promise((resolve) => {
      if (inputValue.length > 1) {
        setTimeout(() => {
          resolve(filterAddPostalCodes(inputValue));
        }, 1000);
      }
    });

  const submitAddFormHandler = async (values) => {
    var val = {
      address: {
        arnum: values.arnum,
        dellocname: values.dellocname,
        addr1: addAddValue,
        addr2: values.addr2,
        postcode: addPostValue,
        city: addCityValue,
        state: addStateValue,
        country: addCountryValue,
        phone: values.phone,
        uuid: values.uuid.toString(),
        ptc: values.ptc,
        ccnum: userDetails.applycorpsetting ? costCenter.ccnum : null
      }
    }
    await Axios.post('/profile/location/upsert', val)
      .then(function (response) {
        if (response && response.status == 200 && response.data?.data?.addresses != null) {
          setInitialAddValue(defaultAddressValue);
          handleClose();
          toast.success('Shipping Address updated successfully.', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
            transition: Slide,
          });
          setAddressDetails(false);
          setAddressDetails(response.data?.data?.addresses);
          // getAccountDetails(values.arnum);
        }
        else {
          var errorMsg = 'Shipping Address add/update failed.'
          errorMsg += ` Error: ${response.data.errordetail[0]?.error}`;
          toast.error(errorMsg, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Flip,
          })
        }
      });
  }

  useEffect(async () => {
    if (addAddValue || addValue) {
      window.setPostalCode(addPostValue ?? addAddValue);
    }
  }, [addAddValue])

  const handleAddEditAddress = (e, uuid = false) => {
    if (!uuid) {
      // setAddressEditDetails(defaultAddressValue);
      var defaultValue = defaultAddressValue;
      defaultValue.arnum = AuthVerify.getUser().arnum;
      defaultValue.uuid = Date.now();
      defaultValue.ptc = defaultAddressValue.ptc ?? '';
      defaultValue.ccnum = costCenter.ccnum;
      setInitialAddValue(defaultValue);
      setAddAddValue('');
      setAddCountryValue('');
      setAddStateValue('');
      setAddCityValue('');
    }
    else {
      var details = addressDetails.filter(i => i.uuid === uuid)[0];
      setAddCountryValue(details.country);
      setAddStateValue(details.state);
      setAddCityValue(details.city);
      handleAddCountryChange({ target: { value: details.country } })
      setAddPostValue(details.postcode);
      setAddAddValue(details.addr1);
      setInitialAddValue(details)
    }
    handleShow();
  }

  const datesAreSame = (date1, date2) => {
    return (date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate())
  }

  const dateChangeEvent = (date) => {
    let selectedDate = new Date(date ?? createdat)
    if (cartDetails.shipdeldatesettings) {
      let shipdeldatesettings = cartDetails.shipdeldatesettings[0];
      if (shipdeldatesettings.specificdate) {
        setSpecificDateFound(true);
        let specificdate = new Date(shipdeldatesettings.specificdate);
        let mindate = new Date(shipdeldatesettings.mindate);
        if (datesAreSame(specificdate, selectedDate)) {
          setCreatedat(selectedDate);
          setReason('');
          return true;
        }
        else {
          setAskingDate(specificdate);
          setConfirmationModal(true);
        }

      }
      else {
        setSpecificDateFound(false);
        let available = isThisDateAvailable(shipdeldatesettings.dow, selectedDate.getDay());
        if (available) {
          setCreatedat(selectedDate);
          setReason('');
          return true;
        } else {
          setAskingDate(selectedDate);
          // setCreatedat(new Date(shipdeldatesettings.mindate));
          setConfirmationModal(true);
          // toast.error(`You can't select this date for delivery. Please select any ${availableDays(shipdeldatesettings.dow)} for delivery.`, {
          //   position: toast.POSITION.TOP_CENTER,
          //   autoClose: 3000,
          //   transition: Flip,
          // })
        }
      }
    }

  }
  const checkSpecificDate = () => {
    if (specificDateFound) {
      setReasonModel(true);
    } else {
      checkPaymentgateway();
    }
  }

  const availableDays = (dow) => {
    let days = dow.filter(x => x.available == true).map(obj => obj.day);
    return days.toString();
  }

  const isThisDateAvailable = (dow, day) => {
    let available = false;
    dow.forEach(element => {
      if (element.day == "SATURDAY" && day == 6) {
        available = element.available;
      }
      else if (element.day == "SUNDAY" && day == 0) {
        available = element.available;
      }
      else if (element.day == "MONDAY" && day == 1) {
        available = element.available;
      }
      else if (element.day == "TUESDAY" && day == 2) {
        available = element.available;
      }
      else if (element.day == "WEDNESDAY" && day == 3) {
        available = element.available;
      }
      else if (element.day == "THURSDAY" && day == 4) {
        available = element.available;
      }
      else if (element.day == "FRIDAY" && day == 5) {
        available = element.available;
      }
    });
    return available;
  }

  const submitForApproval = async () => {
    // SubmitForApproval
    // https://devb2b.bizpoint-intl.com:3082/api/cart/updatestatus/:refnum
    await AuthVerify.submitForApproval(cartDetails).then(result => {
      if (result) {
        setCartDetails(false);
        navigate('/my-account');
      }
    });
  }

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleChangeRequestor = (e, setFieldValue) => {
    console.log(e.target.value)
    const found = requestors.find((item) => item.value == e.target.value);
    console.log(found)
    setFieldValue("shipptc", found?.label ?? '');
    setFieldValue("shipphone", found?.phone ?? '');
  }

  return (
    <>
      <Space
        direction="vertical"
        style={{
          width: '100%',
        }}
      >
        <Spin spinning={spinner} delay={500} size="large">

          <div className="page-content checkout-page" style={{ marginTop: "40px" }}>

            <h3 className="checkout-sep">
              {checkoutTitle || "Checkout Information"}
            </h3>
            <Formik
              initialValues={initialVal}
              validationSchema={Yup.object().shape({
                reqName: Yup.string(),
                email: Yup.string(),
                companyName: Yup.string(),
                contact: Yup.string(),
                address1: Yup.string(),
                country1: Yup.string(),
                state1: Yup.string(),
                city1: Yup.string(),
                zipCode1: Yup.number(),
                address2: Yup.string(),
                remarks: Yup.string()
              })}
              validate={(values) => {
                let errors = {};
                if (userDetails?.role == "Corporate") {
                  if (!values.reqName || values.reqName == '') {
                    errors.reqName = "Requestor Name is required";
                  }
                  else if (!values.email || values.email == '') {
                    errors.email = "Email is required";
                  }
                  else if (!addValue || addValue == '') {
                    errors.address1 = "Address 1 is required";
                  }
                  else if (addValue.length > 49) {
                    errors.address1 = "Address 2 must be at most 50 characters";
                  }
                  else if (!createdat) {
                    errors.deliveryDate = "Delivery Date is required";
                  }
                  else if (values.remarks && values.remarks.length>60) {
                    errors.remarks = "Remarks must be at most 60 characters";
                  }
                }
                // if (!selectedShippingMode && shippingModes.length>0) {
                //   errors.shipmode = "Shipping Mode is required";
                // }
                if (!selectedPaymentMode) {
                  errors.paymode = "Payment Mode is required";
                }
                return errors;
              }}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                setSubmitting(false);

                //setFilledInfo(true);
                submitFormHandler(values);
                // submitFormHandler(values);
                // resetForm();
              }}
              enableReinitialize
            >
              {(props) => {
                const {
                  values,
                  setFieldValue,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  errors, touched
                } = props;
                return (
                  <Form onSubmit={handleSubmit}>
                    <div className="box-border">
                      <div className="form-list">

                        <h2>Shipping Address Information</h2>
                        <div className="box-account" style={{ display: "grid" }}>
                          <div className="header-nav-dropdown-wrapper header-nav-dropdown-wrapper-1">
                            {
                              addressDetails.length > 0 && addressDetails.map((item, i) => {
                                return (
                                  <div className="jtv-custom-box" style={{ width: "18%", cursor: "pointer", border: shippingAddress == item.dellocname ? "3px solid #5aa0dd" : "1px solid rgb(196, 196, 196)", marginTop: "10px" }}>
                                    <h5 className="heading" style={{ margin: "0 20px", textAlign: "left" }}>
                                      <i
                                        className="fa fa-clipboard"
                                        style={{
                                          fontSize: "20px",
                                          padding: "0",
                                          marginTop: "20px",
                                          border: "0",
                                          background: "transparent",
                                        }}
                                      ></i>{" "}<span style={{ fontSize: "18px", fontWeight: "bold", paddingLeft: "10px" }}>Address {i + 1}
                                      {editPermission && <i className="fa fa-edit" style={{ cursor: "pointer", float: "right", fontSize: "20px", padding: "0px", color: "green", border: 'none', backgroundColor: 'none', paddingTop: '3px' }} onClick={(e) => { handleAddEditAddress(e, item.uuid) }}></i>}
                                      </span>
                                    </h5>
                                    <div className="addressDetails" onClick={() => setShippingAddress(item.dellocname)}>
                                      <p>Location name <b>: {item.dellocname ?? "N/A"}</b></p>
                                      <p>Postcode <b>: {item.postcode ?? "N/A"}</b></p>
                                      <p>Address 1 <b>: {item.addr1 ?? "N/A"}</b></p>
                                      <p>Address 2 <b>: {item.addr2 ?? "N/A"}</b></p>
                                      <p>Country <b>: {item.country ?? "N/A"}</b></p>
                                      {/* <p>City <b>: {item.city ?? "N/A"}</b></p>
                                      <p>State <b>: {item.state ?? "N/A"}</b></p> 
                                      <p>Mobile <b>: {item.phone ?? "N/A"}</b></p>
                                      <p>Contact Person <b>: {item.ptc ?? "N/A"}</b></p>*/}
                                    </div>
                                    {/* {shippingAddress==item.dellocname && <small style={{color: "#3c763d"}}>Selected</small>} */}
                                    <p></p>
                                  </div>
                                )
                              })
                            }
                            {addNewPermission &&
                            <div className="jtv-custom-box jtv-custom-box-custom" style={{ width: "18%", marginTop: "10px" }} onClick={(e) => handleAddEditAddress(e)}>
                              <i className="fa fa-plus"></i>
                              <h5 className="heading" style={{ marginBottom: "34px" }}>
                                Add New Shipping Address
                              </h5>
                              {/* <small style="color: #3c763d;">Active</small>  */}
                              <p></p>
                            </div>}
                          </div>
                        </div>
                        {userDetails?.role == "Corporate" &&
                          <>
                          <Row>
                            <Col sm={6}>
                              <InputField
                                Labels="Contact Person"
                                Type="text"
                                Name="shipptc"
                                value={values.shipptc}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className='form-control'
                                ReadOnly={true}
                              />
                            </Col>
                            <Col sm={6}>
                              <InputField
                                Labels="Contact No."
                                Type="text"
                                Name="shipphone"
                                value={values.shipphone}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className='form-control'
                                ReadOnly={true}
                              />
                            </Col>
                          </Row>
                            <hr />
                            <h2>Billing Address Information</h2>
                            <Row>
                              <Col sm={6}>
                                {/* <InputField
                                  Labels="Requestor Name"
                                  Type="text"
                                  Name="reqName"
                                  value={values.reqName}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={!!errors.reqName}
                                  className={(errors.reqName && touched.reqName) ? 'is-invalid' : 'form-control'}
                                /> */}
                                <div className="custom_select">
                                  <SlectInputField
                                    Labels="Requestor Name"
                                    Name="reqName"
                                    placeHolder="Select Requestor"
                                    emptySelection={{ value: '', label: 'Select Requestor' }}
                                    options={requestors}
                                    // value={values.country1}
                                    value={values.reqName}
                                    onChange={e => {handleChange(e); handleChangeRequestor(e, setFieldValue)}}
                                    onBlur={handleBlur}
                                    className={
                                      (errors.reqName && touched.reqName
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                </div>
                                <InputField
                                  Labels="Email Address"
                                  Type="text"
                                  Name="email"
                                  value={values.email}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={!!errors.email}
                                  className={(errors.email && touched.email) ? 'is-invalid' : 'form-control'}
                                  ReadOnly = {true}
                                />
                              </Col>
                              <Col sm={6}>
                                {userDetails.role != "Individual" &&
                                  <InputField
                                    Labels="Company Name"
                                    Type="text"
                                    Name="companyName"
                                    value={values.companyName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.companyName}
                                    className={(errors.companyName && touched.companyName) ? 'is-invalid' : 'form-control'}
                                    ReadOnly = {true}
                                  />
                                }
                                <InputField
                                  Labels="Contact No."
                                  Type="text"
                                  Name="contact"
                                  value={values.contact}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={!!errors.contact}
                                  className={(errors.contact && touched.contact) ? 'is-invalid' : 'form-control'}
                                  ReadOnly = {true}
                                />
                              </Col>
                            </Row>
                            {/* <br/>
                    <CheckboxField
                          Type="checkbox"
                          Name="sameAsBillingInfo"
                          Labels="Same as Shipping Address"
                          value="sameAsBillingInfo"
                          checked={values.sameAsBillingInfo}
                          onChange={(event)=>{setSameAsShippingAddress(event.target.checked)}}
                          onBlur={handleBlur}
                          isInvalid={!!errors.sameAsBillingInfo}
                          className={(errors.sameAsBillingInfo && touched.sameAsBillingInfo) ? 'is-invalid' : 'form-control'}
                        />
                        <br/> */}
                            {!sameAsShippingAddress &&
                              <>
                                <Row>
                                  <Col sm={6} xl={6}>
                                    <div className="custom_select">
                                      <label>Zip / Postal Code</label>
                                      <RASelect
                                        classNamePrefix="lp-copy-sel customPostalCodeSelectCart "
                                        defaultOptions
                                        cacheOptions
                                        onChange={e => { handlePostalChange(e); handleChange(e.label); }}
                                        onBlur={handleBlur}
                                        loadOptions={promiseOptions}
                                        className={(errors.zipCode1 && touched.zipCode1) ? 'is-invalid' : ''}
                                        isDisabled = {true}
                                      />
                                    </div>
                                  </Col>
                                  <Col xl={6} sm={6}>
                                    <InputField
                                      Name="address1"
                                      id="address1"
                                      Labels="Address 1"
                                      Type="text"
                                      value={addValue}
                                      // onChange={handleChange}
                                      onChange={e => { handleChange(e); setAddValue(e.target.value) }}
                                      className={(errors.address1 && touched.address1) ? 'is-invalid' : 'form-control'}
                                      ReadOnly = {true}
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col xl={12} sm={12}>
                                    <Row>
                                      <Col xl={6} sm={6}>
                                        <InputField
                                          Name="address2"
                                          id="address2"
                                          Labels="Address 2"
                                          Type="text"
                                          value={values.address2}
                                          onChange={handleChange}
                                          isInvalid={!!errors.address2}
                                          className={(errors.address2 && touched.address2) ? 'is-invalid' : 'form-control'}
                                          ReadOnly = {true}
                                        />
                                      </Col>
                                      <Col sm={6}>
                                        <div className="custom_select">
                                          <SlectInputField
                                            Labels="Country"
                                            Name="country1"
                                            placeHolder="Select Your Country"
                                            options={countries}
                                            // value={values.country1}
                                            value={countryValue}
                                            onChange={e => { values.state = ""; setStates([]); values.city = ""; setCities([]); handleCountryChange(e); handleChange(e); }}
                                            onBlur={handleBlur}
                                            ReadOnly={true}
                                            className={
                                              (errors.country1 && touched.country1
                                                ? " is-invalid"
                                                : "")
                                            }
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                  </Col>
                                  {/* <Col xl={12} sm={12} xs={12}>
                                    <Row>
                                      <Col sm={6}>
                                        <div className="custom_select">
                                          <SlectInputField
                                            Labels="State/Province"
                                            Type="text"
                                            Name="state1"
                                            placeHolder="Select Your State"
                                            options={states}
                                            // value={values.state1}
                                            value={stateValue}
                                            onChange={e => { handleStateChange(e); handleChange(e); }}
                                            onBlur={handleBlur}
                                            className={
                                              (errors.state1 && touched.state1
                                                ? " is-invalid"
                                                : "")
                                            }
                                          />
                                        </div>
                                      </Col>
                                      <Col sm={6}>
                                        <div className="custom_select">
                                          <SlectInputField
                                            Labels="City"
                                            Type="text"
                                            Name="city1"
                                            placeHolder="Select Your City"
                                            // value={values.city1}
                                            value={cityValue}
                                            onChange={e => { handleCityChange(e); handleChange(e); }}
                                            onBlur={handleBlur}
                                            options={cities}
                                            className={
                                              errors.city1 && touched.city1
                                                ? " is-invalid"
                                                : ""
                                            }
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                  </Col> */}
                                </Row>
                              </>
                            }

                            <hr />
                            {cartDetails.carth?.budgetdisplay && <>
                              <h2>Budget Information</h2>
                              <br />
                              <Row>
                                <Col xs={12} sm={12}>
                                  <div className="recent-orders">
                                    <div className="title-buttons"><strong>Budget</strong>
                                      <div className="dropdown block-company-wrapper hidden-xs">
                                        <select style={{ border: 'none', padding: '0', color: 'blue' }} onChange={(e) => loadBudget(e.target.value)} value={selectedBudget}>
                                          {availableBudgets && availableBudgets.length > 1 && <option style={{ textAlign: 'center', padding: "5px", cursor: "pointer", color: 'blue' }} value={0} disabled selected>Select Budget</option>}
                                          {availableBudgets && availableBudgets.length > 0 ? availableBudgets.map((item, index) => {
                                            return (
                                              <option key={index} style={{ textAlign: 'center', padding: "5px", cursor: "pointer" }} value={item.budgetnum}>{item.budgetdesc} </option>
                                            )
                                          })
                                            :
                                            <option style={{ textAlign: 'center', padding: "5px", cursor: "pointer" }} disabled={true} selected={true}>No Budget Found</option>
                                          }
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="table-responsive">
                                    <table className="data-table" id="my-orders-table">
                                      <thead>
                                        <tr className="first last">
                                          <th></th>
                                          <th>Total Amount</th>
                                          <th>Approved Amount</th>
                                          <th>Pending Amount</th>
                                          <th>Current Order Amount</th>
                                          <th>Balance Amount</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr className="first odd">
                                          <td>Amount:</td>
                                          <td>{loadBudgetData?.totalamt ?? 0}</td>
                                          <td>{loadBudgetData?.approvedamt ?? 0}</td>
                                          <td>{loadBudgetData?.pendingamt ?? 0}</td>
                                          <td>{loadBudgetData?.currentorderamt ?? 0}</td>
                                          <td>{loadBudgetData?.balanceamt ?? 0}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </Col>
                              </Row>
                              <hr />
                            </>}
                            <Row>
                              <Col sm={6}>
                                <h2>PO Information</h2>
                                <InputField
                                  Labels="PO No."
                                  Type="text"
                                  Name="poNo"
                                  value={values.poNo}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={!!errors.poNo}
                                  className={(errors.poNo && touched.poNo) ? 'is-invalid' : 'form-control'}
                                />
                                <InputField
                                  Labels="Description"
                                  Type="text"
                                  Name="description"
                                  value={values.description}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={!!errors.description}
                                  className={(errors.description && touched.description) ? 'is-invalid' : 'form-control'}
                                />
                              </Col>
                            </Row>
                            <br />
                            {cartDetails.carth?.approvaldisplay && <>
                              <hr />
                              <h2>Approval Loop</h2>
                              <ApprovalLoop carth={cartDetails.carth} />
                            </>}
                            <Row>
                              {cartDetails.carth?.shipdeldatedisplay && <>
                                <Col sm={6}>
                                  <h2>Delivery Date</h2>
                                  {/* <InputField
                            Labels="Select Date"
                            Type="date"
                            Name="shipdeldate"
                            value={createdat}
                            onChange={(e)=>{console.log(e); handleChange(e); setCreatedat(e.target.value)}}
                            onBlur={handleBlur}
                            isInvalid={!!errors.shipdeldate}
                            className={(errors.shipdeldate && touched.shipdeldate ) ? 'is-invalid' : 'form-control'}
                          /> */}
                                  <CustomDateTimePicker
                                    Labels="Select Date"
                                    value={createdat ? new Date(createdat) : false}
                                    onChange={(e) => { handleChange({ type: "change", target: { value: e } }); dateChangeEvent(e); }}
                                    minDate={cartDetails?.shipdeldatesettings ? new Date(cartDetails?.shipdeldatesettings[0].mindate) : false}
                                    className={(errors.shipdeldate && touched.shipdeldate) ? 'is-invalid' : 'form-control'}
                                  />
                                  {errors.deliveryDate ? (
                                    <>
                                      <span
                                        style={{
                                          color: "red",
                                          // paddingLeft: "20px",
                                        }}
                                      >
                                        {" ! "} {errors.deliveryDate}{" "}
                                      </span>
                                      <br />
                                    </>
                                  ) : (
                                    ""
                                  )
                                  }
                                  <span style={{color: "blue"}}>{cartDetails?.carth?.shipdeldatemessage2}</span>
                                </Col>
                              </>}
                              <Col sm={12} className="heading-counter warning text-center" style={{ color: "#f5c328", fontWeight: "bold" }}>
                                {cartDetails && cartDetails.carth?.shipdeldatedisplay && <><br />
                                  <span>
                                    {cartDetails.carth?.shipdeldatemessage}.
                                  </span>
                                </>
                                }
                              </Col>
                            </Row>
                          </>
                        }
                        <br />
                        {shippingModes && shippingModes.length > 0 && <>
                          <h2>Shipping Information</h2>
                          <div className="box-border">
                            <ul>
                              <Row>
                                <Col sm={6}>
                                  <label className="required">Shipping Method</label>
                                  <br />
                                  {shippingModes && shippingModes.map((item, i) => {
                                    return (<li key={i}>
                                      <label style={{ paddingRight: "5px" }}>
                                        <input
                                          type="checkbox"
                                          name="deliveryType"
                                          value={item.varid}
                                          checked={item.varid === selectedShippingMode}
                                          onChange={(e) => { handleChange(e); e.target.checked ? setSelectedShippingMode(item.varid) : setSelectedShippingMode(false) }}
                                          onBlur={handleBlur}
                                        />
                                        {item.varvalue}
                                      </label>
                                    </li>)
                                  })}
                                  {errors.shipmode ? (
                                    <>
                                      <span
                                        style={{
                                          color: "red",
                                          // paddingLeft: "20px",
                                        }}
                                      >
                                        {" ! "} {errors.shipmode}{" "}
                                      </span>
                                      <br />
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </Col>
                                {/* <Col sm={6}>
                              <label className="required">
                                Shipping Method
                              </label>
                              <br />
                              {shippingModes && shippingModes.map((item,i)=>{
                                return (<li key={i}>
                                  <label for="radio_button_3">
                                    <input
                                      type="radio"
                                      value={item.varid}
                                      name="deliveryType"
                                    />
                                    <strong> {item.varvalue}</strong>
                                  </label>
                                </li>)
                              })}
                            </Col> */}
                              </Row>
                            </ul>
                          </div>
                        </>}
                        <h2>Payment Information</h2>
                        <div className="box-border">
                          <ul>
                            <Row>
                              <Col sm={6}>
                                <label className="required">Payment Method</label>
                                <br />
                                {paymentModes && paymentModes.map((item, i) => {
                                  return (<li key={i}>
                                    <label style={{ paddingRight: "5px" }}>
                                      <input
                                        type="checkbox"
                                        name="paymode"
                                        value={item.varid}
                                        checked={item.varid === selectedPaymentMode}
                                        onChange={(e) => { handleChange(e); e.target.checked ? setSelectedPaymentMode(item.varid) : setSelectedPaymentMode(false) }}
                                        onBlur={handleBlur}
                                      />
                                      {item.varvalue}
                                    </label>
                                  </li>)
                                })}
                                {errors.paymode ? (
                                  <>
                                    <span
                                      style={{
                                        color: "red",
                                        // paddingLeft: "20px",
                                      }}
                                    >
                                      {" ! "} {errors.paymode}{" "}
                                    </span>
                                    <br />
                                  </>
                                ) : (
                                  ""
                                )}
                              </Col>
                            </Row>
                          </ul>
                        </div>

                        <hr />
                        <Row>
                          <Col sm={12}>
                            <h2>Remarks</h2>
                            <label htmlFor="name" className="required">
                              Write your remarks here (Not more than 60 characters)
                            </label>
                            <InputField
                              Name="remarks"
                              id="remarks"
                              Type="text"
                              value={values.remarks}
                              onChange={handleChange}
                              isInvalid={!!errors.remarks}
                              className={(errors.remarks && touched.remarks) ? 'is-invalid' : 'form-control'}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>

                    <div className="cart_navigation">
                      <Link to="/shopping-cart">
                        <button
                          className="button continue-shopping"
                          title="Continue shopping"
                          type="button"
                        >
                          <span>Previous</span>
                        </button>
                      </Link>

                      {cartDetails.carth?.confirmbtndisplay &&
                        <button
                          className="button btn-proceed-checkout"
                          title="Proceed to Checkout"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          <span>Confirm Order</span>
                        </button>
                      }

                      {/* {userDetails && userDetails.role=='Corporate' && cartDetails.carth?.submitbtndisplay && */}
                      {cartDetails.carth?.submitbtndisplay &&
                        // <Link to="/shopping-cart-approval-info">
                        <button
                          className="button btn-proceed-checkout"
                          title="Proceed to Checkout"
                          type="submit"
                          disabled={isSubmitting}
                          style={{
                            marginRight: "10px",
                            background: "#337ab7",
                            border: "0px solid #337ab7",
                          }}
                          onClick={() => {
                            setSubmitForApp(true);
                            // submitForApproval();
                          }}
                        >
                          <span>Submit for Approval</span>
                        </button>
                        // </Link>
                      }

                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>

        </Spin>
      </Space>
      <Modal show={show} dialogClassName="modal-90w" animation={false} fade={false} style={{ opacity: 1 }} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Address Information</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={initialAddValue}
            validationSchema={Yup.object().shape({
              dellocname: Yup.string().min(2).required("Location name is required"),
              addr1: Yup.string().max(49, 'Address 1 must be at most 50 characters'),
              addr2: Yup.string().max(49, 'Address 2 must be at most 50 characters'),
              // postcode: Yup.number().required("Please enter your zip/postal code"),
              country: Yup.string().required("Country is required"),
              state: Yup.string(),//.required("State is required"),
              city: Yup.string(),//.required("City is required"),
              ptc: Yup.string().required("Contact Person is required"),
              phone: Yup.string().min(8, "Contact number must be of 8 digits").required("Please enter your contact number")
            })}
            validate={(values) => {
              let errors = {};
              // if (!values.addr1) {
              //   errors.addr1 = "Required";
              // }
              if (addAddValue == '') {
                errors.addr1 = "Address 1 is required";
              }
              else if (addAddValue.length > 49) {
                errors.addr1 = "Address 1 must be at most 50 characters";
              }
              if (applycorpsetting && (!values.ccnum || values.ccnum == '')) {
                errors.ccnum = "Cost center is required";
              }
              return errors;
            }}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              // actions.setStatus(undefined); 
              // setTimeout(() => {
              //   actions.setStatus({
              //     addr1: 'This is email already exists.'
              //   });
              // }, 500);
              setSubmitting(false);
              submitAddFormHandler(values);
            }}
            enableReinitialize
          >
            {(props) => {
              const {
                values,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                errors, touched
              } = props;
              return (
                <Form onSubmit={handleSubmit}>
                  <div className="box-border">
                    <div className="form-list">
                      <Row>
                        <Col xl={6} sm={6}>
                          <InputField
                            Name="dellocname"
                            id="dellocname"
                            Labels="Location name"
                            Type="text"
                            value={values.dellocname}
                            onChange={handleChange}
                            isInvalid={!!errors.dellocname}
                            className={(errors.dellocname && touched.dellocname) ? 'is-invalid' : 'form-control'}
                          />
                        </Col>
                        <Col sm={6} xl={6}>
                          <div className="custom_select">
                            <label>Zip / Postal Code</label>
                            <RASelect
                              classNamePrefix="lp-copy-sel customPostalCodeSelect "
                              defaultOptions
                              cacheOptions
                              onChange={e => { handleAddPostalChange(e); handleChange(e.label); }}
                              onBlur={handleBlur}
                              loadOptions={addPromiseOptions}
                              className={(errors.zipCode1 && touched.zipCode1) ? 'is-invalid' : ''}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xl={12} sm={12}>
                          <Row>
                            <Col xl={6} sm={6}>
                              <InputField
                                Name="addr1"
                                id="addr1"
                                Labels="Address 1"
                                Type="text"
                                value={addAddValue}
                                // onChange={handleChange}
                                onChange={e => { handleChange(e); setAddAddValue(e.target.value) }}
                                className={(errors.addr1 && touched.addr1) ? 'is-invalid' : 'form-control'}
                              />
                            </Col>
                            <Col xl={6} sm={6}>
                              <InputField
                                Name="addr2"
                                id="addr2"
                                Labels="Address 2"
                                Type="text"
                                value={values.addr2}
                                onChange={handleChange}
                                isInvalid={!!errors.addr2}
                                className={(errors.addr2 && touched.addr2) ? 'is-invalid' : 'form-control'}
                              />
                            </Col>
                          </Row>
                        </Col>

                        <Col xl={12} sm={12} xs={12}>
                          <Row>
                            <Col sm={6}>
                              <div className="custom_select">
                                <SlectInputField
                                  Labels="Country"
                                  Name="country"
                                  placeHolder="Select Your Country"
                                  options={countries}
                                  value={values.country}
                                  onChange={e => { values.state = ""; setStates([]); values.city = ""; setCities([]); handleAddCountryChange(e); handleChange(e); }}
                                  onBlur={handleBlur}
                                  className={
                                    (errors.country && touched.country
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                              </div>
                            </Col>
                            {/* <Col sm={6}>
                              <div className="custom_select">
                                <SlectInputField
                                  Labels="State/Province"
                                  Type="text"
                                  Name="state"
                                  placeHolder="Select Your State"
                                  options={addStates}
                                  value={values.state}
                                  onChange={e => { handleAddStateChange(e); handleChange(e); }}
                                  onBlur={handleBlur}
                                  className={
                                    (errors.state && touched.state
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                              </div>
                            </Col> */}
                            <Col xl={6} sm={6}>
                              <InputField
                                Name="phone"
                                id="phone"
                                Labels="Contact No."
                                Type="text"
                                value={values.phone}
                                onChange={handleChange}
                                isInvalid={!!errors.phone}
                                className={(errors.phone && touched.phone) ? 'is-invalid' : 'form-control'}
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col xl={12} sm={12} xs={12}>
                          <Row>
                            <Col xl={6} sm={6}>
                              <InputField
                                Name="ptc"
                                id="ptc"
                                Labels="Contact Person"
                                Type="text"
                                value={values.ptc}
                                onChange={handleChange}
                                isInvalid={!!errors.ptc}
                                className={(errors.ptc && touched.ptc) ? 'is-invalid' : 'form-control'}
                              />
                            </Col>
                            {applycorpsetting &&
                              <Col sm={6}>
                                <div className="custom_select">
                                  <SlectInputField
                                    Labels="Cost Center"
                                    Type="text"
                                    Name="ccnum"
                                    placeHolder="Select Your Cost Center"
                                    value={values.ccnum}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    options={costCenters}
                                    className={
                                      errors.ccnum && touched.ccnum
                                        ? " is-invalid"
                                        : ""
                                    }
                                  />
                                </div>
                              </Col>
                            }
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </div>
                  <Row>
                    <div className="cart_navigation">
                      <button
                        className="button btn-proceed-checkout btn-danger"
                        title="Proceed to Checkout"
                        type="button"
                        onClick={handleClose} style={{
                          marginRight: "10px",
                          padding: "10px"
                        }}
                      >
                        <span>Close</span>
                      </button>


                      <button
                        className="button btn-proceed-checkout"
                        title="Proceed to Checkout"
                        type="submit"
                        style={{
                          marginRight: "10px",
                          background: "#337ab7",
                          border: "0px solid #337ab7",
                          padding: "10px"
                        }}
                      >
                        <span>Add/Update</span>
                      </button>
                    </div>

                  </Row>
                </Form>
              );
            }}
          </Formik>
        </Modal.Body>
      </Modal>

      <Modal show={confirmationModal} scrollable={false} size="sm" centered animation={false} fade={false} style={{ opacity: 1, margin: "auto" }} onHide={() => setConfirmationModal(false)}>
        <Modal.Header closeButton={false}>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "center" }}>
          Your selected delivery date is different from company arrangement. Do you still want to proceed?
        </Modal.Body>
        <Modal.Footer>
          <div style={{ float: "right" }}>
            <button
              className="button "
              title="Proceed to Checkout"
              type="button"
              onClick={() => { setConfirmationModal(false); setReasonModel(true); }}
              style={{
                marginRight: "10px",
                padding: "5px"
              }}
            >
              <span>Yes</span>
            </button>
            <button
              className="button button-danger"
              title="Proceed to Checkout"
              type="button"
              onClick={() => { setConfirmationModal(false);setSpinner(false); }}
              style={{
                marginRight: "10px",
                padding: "5px"
              }}
            >
              <span>No</span>
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal show={insuffStockModel} scrollable={false} size="sm" centered animation={false} fade={false} style={{ opacity: 1, margin: "auto" }} onHide={() => setInsuffStockModel(false)}>
        <Modal.Header closeButton={false}>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "center" }}>
          There is insufficient stock for your item(s). Do you want to proceed with partial delivery?
        </Modal.Body>
        <Modal.Footer>
          <div style={{ float: "right" }}>
            <button
              className="button "
              title="Proceed to Checkout"
              type="button"
              onClick={() => { allowPartial.current = true; setInsuffStockModel(false); checkSpecificDate(); }}
              style={{
                marginRight: "10px",
                padding: "5px"
              }}
            >
              <span>Yes</span>
            </button>
            <button
              className="button button-danger"
              title="Proceed to Checkout"
              type="button"
              onClick={() => { setInsuffStockModel(false); setEditOrderModel(true);setSpinner(false); }}
              style={{
                marginRight: "10px",
                padding: "5px"
              }}
            >
              <span>No</span>
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal show={editOrderModel} scrollable={false} size="sm" centered animation={false} fade={false} style={{ opacity: 1, margin: "auto" }} onHide={() => setEditOrderModel(false)}>
        <Modal.Header closeButton={false}>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "center" }}>
          Please edit your order in order to proceed.
        </Modal.Body>
        <Modal.Footer>
          <div style={{ float: "right" }}>
            <button
              className="button button-danger"
              title="Proceed to Checkout"
              type="button"
              onClick={() => { setEditOrderModel(false); }}
              style={{
                marginRight: "10px",
                padding: "5px"
              }}
            >
              <span>Ok</span>
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal show={reasonModel} scrollable={false} size="lg" centered animation={false} fade={false} style={{ opacity: 1, margin: "auto" }} onHide={() => setReasonModel(false)}>
        <Modal.Header closeButton={false}>
          <Modal.Title>Reason for special arrangement</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "center" }}>
          <Row>
            <Col md={4}>
              <label>Enter your reason</label>
            </Col>
            <Col md={8}>
              <input className="form-control" value={reason} onChange={e => setReason(e.target.value)} type={"text"} />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <div style={{ float: "right" }}>
            <button
              className="button button-danger"
              title="Proceed to Checkout"
              type="button"
              onClick={() => { setReasonModel(false); setCreatedat(askingDate); }}
              style={{
                marginRight: "10px",
                padding: "5px"
              }}
            >
              <span>Ok</span>
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ShoppingCartInfo;
